module.exports = "/next-static/_next/static/images/block_image_personalize_branding-f9cd7dabb38336104f29d25576ef44f1.png";